export default {"src":"/_next/static/media/share.158fe472.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};